import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { skip } from "rxjs/operators";

import { BusAuctionFilterService } from '../../../home/services/bus-auction-filter.service';
import { AuctionFilter } from '../../../home/models/auction-filter';
import { LoggingService } from '../../../../services/logging.service';

const apiServer = environment.apiServer;
declare var $: any;

class SearchFilter {
  search: string;
}

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}


@Component({
  selector: 'app-home-main-modal-drag',
  templateUrl: './home-main-modal-drag.component.html',
  styleUrls: ['./home-main-modal-drag.component.sass']
})
export class HomeMainModalDragComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];
  private opened = false;

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('drugCheckInput') nameInputModel: QueryList<any>;

  dt: DataTables.Api;
  modelDrugFilter: AuctionFilter = new AuctionFilter();
  modelAuctionFilter: AuctionFilter = new AuctionFilter();
  searchFilter: SearchFilter = new SearchFilter();
  dtOptionsDrugs: DataTables.Settings = {};
  dataSetDrugs: any;
  checkedDrug: string[];

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private loggingService: LoggingService, private cd: ChangeDetectorRef) {
    this.checkedDrug = [];
  }

  onFieldChange() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalDragComponent.onFieldChange', null, 'Field change started');
      
      this.dt.ajax.reload();
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalDragComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalDragComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }

  ngOnInit() {
    this.subs.push(
      this.bus.currentClearModalFilter$
        .pipe(skip(1))  // При инициализации фильтр уже очищен
        .subscribe(key => {
          if (key === 'mnn' || key === "all") {
            this.nameInputModel.forEach(function (item) {
              item.nativeElement.checked = false;
            });
            this.checkedDrug = [];

            if (key !== "all") {
              this.onAuctionFilter();
            }
          }
        })
    );

    const that = this;

    $('#modalDrugs').off('shown.bs.modal').on('shown.bs.modal', function () {
      if (!that.opened) {
        that.opened = true;
        that.dt.ajax.reload();
      }
    });

    this.dtOptionsDrugs = {
      pagingType: 'full_numbers',
      pageLength: 50,
      serverSide: true,
      processing: true,
      autoWidth: false,
      order: [1],
      deferLoading: 0,
      dom: 'tip',
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: 'Нет совпадающих значений для поиска',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.search = this.searchFilter.search;

        that.http.post<DataTablesResponse>(`${apiServer}/getGoodsShortList`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetDrugs = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
            that.cd.detectChanges();
          });
      },
      columnDefs: [
        {
          orderable: false,
          className: 'select-checkbox',
          targets: 0
        },
      ]
    };

  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onSelectedRow(event, value) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalDragComponent.onSelectedRow', null, 'Row selection started');
      
      if (event.target.checked) {
        this.checkedDrug.push(value);
      } else {
        for (let i = 0; i < this.checkedDrug.length; i++) {
          if (this.checkedDrug[i] === value) {
            this.checkedDrug.splice(i, 1);
          }
        }
      }
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalDragComponent.onSelectedRow', null, 'Row selection completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalDragComponent.onSelectedRow', _error, null, 'Row selection failed');
      throw _error;
    }
  }

  onSelectingRows(event) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalDragComponent.onSelectingRows', null, 'Selecting all rows started');
      
      const that = this;

      this.nameInputModel.forEach(function (item) {
        item.nativeElement.checked = event.target.checked;

        if (event.target.checked) {
          that.checkedDrug.push(item.nativeElement.value);
        } else {
          for (let i = 0; i < that.checkedDrug.length; i++) {
            if (that.checkedDrug[i] === item.nativeElement.value) {
              that.checkedDrug.splice(i, 1);
            }
          }
        }
      });
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalDragComponent.onSelectingRows', null, 'Selecting all rows completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalDragComponent.onSelectingRows', _error, null, 'Selecting all rows failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }

  onAuctionFilter() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalDragComponent.onAuctionFilter', null, 'Auction filter started');
      
      this.modelAuctionFilter.mnn = this.checkedDrug.join(",");
      this.bus.changeFilter(this.modelAuctionFilter);
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalDragComponent.onAuctionFilter', null, 'Auction filter completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalDragComponent.onAuctionFilter', _error, null, 'Auction filter failed');
      throw _error;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-drag/home-main-modal-drag.component.ts